export default __webpack_public_path__ + "static/R1-0b2371f27ceeac0918cffd6f3125ae4e.png";